import React from 'react';

import { NPSSerializer } from '../serializer';

import { NPSStore } from './nps.store';

export const npsStore = new NPSStore(new NPSSerializer());

export const NPSAdapter = React.createContext(npsStore);
